export { default as contact } from "./ContactMessage";
export { default as tip } from "./TipMessage";
export { default as system } from "./SystemMessage";
